<template>
  <HeroSection title="Terms and conditions" class="bg-black" bg-src="/images/audi-wheel.webp" />

  <div class="container py-10 prose">

    <h2>AREA OF APPLICATION</h2>
    <ol>
      <li>The following General Terms and Conditions (the "Terms") shall apply to relationships between
        <strong>driveczech group s.r.o.</strong>, with its registered seat at Korunn&iacute; 2569/108, 101 00
        Praha-Vinohrady, ID. No.: 17383447 (Tax Id. No.: CZ17383447), registered at Commercial register maintained by
        the Prague Municipal Court under file no. C 370951, <a href="mailto:info@driveczech.com">info@driveczech.com</a>, tel.: <a href="tel:+420603427002">+420603427002</a> (the
        "<strong>Company</strong>") and any person who orders unique personal transport, security and other services
        (the "<strong>services</strong>") intermediated by the Company for themselves or for any third party (the
        "<strong>Client</strong>").</li>
      <li>The Company operates the website <a href="https://driveczech.com/">https://driveczech.com/</a> (the
        "<strong>Website</strong>") in order to intermediate the services for the Clients. The unique personal transport
        services are provided by professional third parties (the "<strong>Carrier</strong>") chosen by the Company based
        on the special agreement concluded between the Client and the Carrier (the "<strong>Transport
          agreement</strong>") whereas the conclusion of the Transport agreement is intermediated by the Company who
        accepts the Transport agreement on the Carrier&rsquo;s behalf and on their account.</li>
      <li>The Company is a transport mediator within the meaning of Sec. 2 (10) of Act No. 111/1994 Coll., On Road
        Transport, as amended.</li>
    </ol>

    <h2>Conclusion of Contract</h2>
    <ol>
      <li>The order of the transport and other services (the "<strong>Order</strong>") can be made via the Website or
        sent to the email <a href="mailto:info@driveczech.com">info@driveczech.com</a>. The Order confirmed by the Company is an
        essential part of the Transport agreement.</li>
      <li>The Client shall confirm the Order via the Website, they shall consent to the Terms and makes the payment of
        the price for the services to be provided under the Transport agreement (the "<strong>Price</strong>") via the
        Website.</li>
      <li>The Order send to the Company via e-mail must be confirmed by the Company. When the Order is confirmed, the
        Client shall consent to the Terms and performs the payment of the Price following the instructions of the
        Company.</li>
      <li>The Transport agreement is concluded at the time the Price is duly received unless agreed otherwise via
        e-mail. The confirmation of the conclusion of the agreement, a payment confirmation, the Transport agreement,
        the Terms and GDPR Policy is send to the Client&rsquo;s e-mail. The Transport agreement is stored in electronic
        form by the Company.</li>
    </ol>

    <h2>Course of transport</h2>
    <ol>
      <li>The Client expressly acknowledges that they are obliged to be at the pick-up location in time and arranges at
        least a 30-minute time reserve for force majeure, unfavourable traffic or closures, etc. Otherwise, the Client
        is not entitled to claim damages from the Company.</li>
      <li>If the Client fails to comply with the agreed conditions related to pick-up time and place, they are obliged
        to pay the additional costs incurred, such as waiting time.</li>
      <li>The Client is obliged to pay for every additional distance which was not included in the Order. The Price for
        extra-kilometres according to the pricelist of the Company is stated in the table below:
        <table>
          <thead>
            <tr>
              <td>
                Type of vehicle
              </td>
              <td>
                Price for every additional km
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Maybach</td>
              <td>120 CZK / km</td>
            </tr>
            <tr>
              <td>First Class</td>
              <td>60 CZK / km</td>
            </tr>
            <tr>
              <td>Business Class</td>
              <td>40 CZK / km</td>
            </tr>
            <tr>
              <td>Business Van</td>
              <td>45 CZK / km</td>
            </tr>
          </tbody>
        </table>
        <p>The indicated price for every additional km will
          be increased by applicable VAT and the price is calculated for each started kilometre. The Client is obliged to
          pay for additional kilometres at the moment the transport is completed.</p>
      </li>
      <li>The Price receipt is sent to the Client&rsquo;s e-mail after the completion of the transport.</li>
    </ol>

    <h2>CHANGE OF THE SERVICES</h2>
    <ol>
      <li>If the Client wishes to change the agreed service (even during its course), they will inform the Carrier or
        the Company and the Company will send new quotation to the Client via email. The Company reserves the right not
        to satisfy the Client&apos;s wishes and the cancellation policy provided under Sec. 5 of the Terms shall apply.
      </li>
    </ol>

    <h2>CANCELLATION POLICY</h2>
    <ol>
      <li>The Client has the right to cancel or change the Transport agreement without any fee if the cancelation is
        delivered to the Company via email no later than 24 hours before the pick-up time agreed under the Transport
        agreement. The paid Price is returned to the Client within 10 days of the cancelation to the bank account from
        which the Price was previously paid.</li>
      <li>In the event that the cancelation or change of the Transport agreement is delivered to the Company via e-mail
        less than 23 hours 59 minutes before the agreed pick-up time, the Client is obliged to pay to the Company the
        cancellation fee in the amount of 100 % of the Price (the "<strong>Fee</strong>"). The Company shall
        unilaterally set off the Price against the Fee and the Price is not returned to the Client.</li>
      <li>In the event that the Client fails to provide the necessary cooperation for the provision of the ordered
        transport service (i.t. the Client is not presented on the pick-up time at the agreed place), the Client shall
        pay the Company the Fee. The Company shall unilaterally set off the Price against the Fee and the Price is not
        returned to the Client.</li>
    </ol>

    <h2>PAYMENT TERMS</h2>
    <ol>
      <li>When paying the services in cash, the Carrier accepts only Czech crowns (CZK) and currencies that are
        available on the Website during the booking process. Price paid in cash in foreign currency shall be
        recalculated based on the current exchange rate of the Czech crown determined by the Company on the day of
        pick-up of the Client. The exchange rate valid at the time of the Client&rsquo;s pick-up shall apply.</li>
      <li>Payment by bank transfer (invoice) is only available upon request and based on Company&rsquo;s consent. The
        Company shall require payment of an advanced invoice prior to the provision of the services under the Transport
        agreement. If the Price is not duly paid within the due date indicated in the invoice, the Company has a right
        to cancel the Order and it is not obliged to provide the services. Invoices can only be issued in CZK.</li>
    </ol>


    <h2>Obligations of the Client</h2>
    <ol>
      <li>The Client and other passengers are obliged to behave according to the reasonable instructions of the Carrier
        at the time of transport and in particular to observe the safety and any other statutory regulations related to
        the personal transport (i.e. to fasten seat belt). In the event that the Client/passengers do not comply with
        the Carrier&rsquo;s instructions, the Transport agreement can be cancelled without any refund.</li>
      <li>The Client and other passengers are obliged to behave at all times when using the service under Transport
        agreement in such a way that the Company, the Carrier or a third party does not suffer any damage or other harm
        (i.e. damage caused by poured liquid, vomiting etc.). The Client shall also be liable for damage caused during
        or in connection with the carriage by the passenger if the carriage is ordered on behalf of the Client and the
        passenger&apos;s person differs from the Client&apos;s person.</li>
      <li>In the event of a breach of these obligations, the Client is aware of the liability for damages caused to the
        Company, to the Carrier and/or to third parties by their actions.</li>
      <li>In case of violation of the duty stipulated in Sec. 7 (2) of the Terms, the Client is obliged to pay to the
        Company a contractual penalty in the amount of EUR 500 for each violation of this duty. The Client is liable
        also for any passenger who violated this duty in the vehicle during or in connection with the carriage ordered
        by the Client. The contractual penalty is due within 7 days of the day the Client received the request for a
        payment on their email.</li>
      <li>Smoking (including electronic cigarettes or other devices) is prohibited in the vehicle. The Client is obliged
        to pay a contractual penalty in the amount of EUR 1000 for each violation of this duty. The contractual penalty
        is due within 7 days of the day the Client received the request for a payment on their email.</li>
      <li>If any Client&rsquo;s payment is not timely made by the due date, in addition to the sum due there shall be a
        late payment penalty in an amount equal to 0,5% of the payment due for each day after the date due through and
        including the date paid.</li>
      <li>The application of late payment penalty
        and/or contractual penalty by the Company and/or payment of late payment penalty and/or contractual fines by the
        Client does not release the Client from the obligation to pay the financial obligation owed to the Company and
        does not affect the Company&apos;s right to demand compensation for damage and the Company is entitled to demand
        compensation as well damages exceeding the contractual penalty. The Client is obliged to pay contractual
        penalties regardless of fault. Circumstances excluding liability for breach of the Client&apos;s obligation do
        not affect the obligation to pay contractual penalties.</li>
    </ol>

    <h2>The Liability of the Company</h2>
    <ol>
      <li>The Client acknowledges that services under Transport agreement are not provided by the Company, but always by
        a third-party Carrier and the Company is not in any way responsible or liable for the Carrier&apos;s performance
        of its obligations, in particular for the due and timely provision of the services. The Company shall not be
        liable for any damage or other injury suffered by the Client during/or in connection with the carriage and other
        services.</li>
      <li>In such cases the Company shall provide the Client with the assistance of its brokerage or procurement
        activities in pursuing a claim, in particular as regards contacting the relevant Carrier, in which context the
        Client may contact the Client contacts (telephone line and email address) listed on the Company&apos;s website
        within 5 working days.&nbsp;</li>
      <li>The Company reserves the right to reject or cancel the Trasport agreement without giving any reason. The
        Company undertakes to provide the Client with a carrier service corresponding to the specifications in the
        Order. If the agreed Carrier fails to provide the service for any reason, the Company undertakes to provide a
        replacement available option&nbsp; in accordance with the Order. If this is not possible, the Company is obliged
        to return the Price to the Client immediately, but no later than 14 days.</li>
      <li>The Carrier is liable for the damage caused by them performing the carriage and the Client accepts their
        carriage service by boarding their vehicle. The Client acknowledges that they are not entitled to damages if
        <ol type="a">
          <li>There
            has been a delay in transportation either at the beginning of the Client&rsquo;s boarding or during the
            transport itself due to force majeure. Force majeure is defined as an intervention of a natural disaster,
            weather, weather conditions, a car accident not caused by the Carrier, road congestion caused by road
            repairs or by other reasons, or delay caused by state or administrative intervention &ndash; police
            officers, etc.</li>
          <li>There
            has been a delay in transportation due to the Client or another ordering party (travel agent, hotel, tour
            operator, etc.), for example by not arriving at the agreed time at the agreed place.</li>
          <li>There
            has been damage done to the property of the Client or to his health resulting from a traffic accident not
            caused by the Company&rsquo;s driver or an intermediary carrier&rsquo;s driver, but by another driver,
            animal or person.</li>
          <li>There
            has been damage done to the property of the Client or to his health or life due to any manoeuvre that the
            driver was forced to undertake during transport in order to prevent greater damage or consequences, such as
            the need for sudden braking due to the situation on the road, sharp detours and skidding, where, unless
            proved otherwise, such a manoeuvre is considered necessary, for instance, for avoiding a collision with an
            animal, man, or other vehicle on the road, etc.</li>
          <li>There
            has been damage done due to the obliviousness of the Client or another ordering party (for example,
            forgetting to put baggage into the trunk or forgetting to unload it, loss of small items or cash during
            carriage, etc.).</li>
          <li>The
            Client has suffered damage as a result of a wrong or improperly chosen time of arrival.</li>
        </ol>
      </li>
      <li>Complaints against the Carrier with a
        claim for damages must be made without undue delay, but no later than 30 days in writing or by e-mail, after
        which the claim for damages expires. The Client is not entitled to compensation if a replacement car of the same
        type/category or the same car in a different colour and equipment is provided or if the damage is caused by
        force majeure that the Company cannot influence.</li>
    </ol>

    <h2>Information for the Consumers</h2>
    <ol>
      <li>The Client, as the consumer within the meaning of the Czech law (the "<strong>Consumer</strong>"), is entitled
        to complain without undue delay and request related claim in the event that the intermediation service was not
        duly or timely provided by the Company.</li>
      <li>The Consumer is also entitled to complain against the Carrier without undue delay in case that the service was
        not duly or timely provided. In this event the Company shall provide the necessary and reasonable cooperation to
        the Consumer, especially they shall send the contact details of the Carrier.</li>
      <li>The Consumer might use contact details of the Company published on the Website and provided in this Terms.
      </li>
      <li>In accordance with Sec. 1829 (1) of the Act. No. 89/2012 Coll., the Civil Code, as amended (the "<strong>Civil
          Code</strong>") the Consumer has the right to withdraw from the agreement without giving a reason, within
        fourteen days from the date of conclusion of the agreement. However, the Consumer cannot withdraw from the
        contract without giving a reason, if the provision of the service has already begun with his prior express
        consent before the expiry of the period for withdrawal from the contract and the service has been provided (the
        right to withdraw from the contract expires with the provision of the service). If the Consumer withdraws from
        the contract during the provision of such a service, he is obliged to pay a proportional part of the agreed
        price for the performance provided up to the moment of withdrawal from the contract (cancellation fee).</li>
      <li>Unless otherwise stated in the Terms (refund policy), the Consumer cannot withdraw from the Transport
        agreement for the carriage of persons and from the contract for the security services without giving a reason
        based on Sec. 1829 of the Civil Code, if according to the contract the services are to be performed on a certain
        date or during a certain period.</li>
      <li>The Consumer may withdraw from the agreement in accordance with the Terms by any unambiguous statement made
        against the Company.</li>
      <li>A Consumer, whose right has been affected by unfair trade practices in the sense of the law on Consumer
        protection, can withdraw from the contract within 90 days of the conclusion of the contract, or demand a
        reasonable price reduction in a range corresponding to the seriousness of the unfair trade practices.</li>
      <li>If the delay or other breach of the contract made by the other contractual party (the Carrier) is a material
        breach of the contract, the Consumer may, in accordance with the provisions of Sec. 1977 and Sec. 2002 of the
        Civil Code, withdraw from the contract without undue delay after learning about the delay. In accordance with
        the provisions of Sec. 1978 of the Civil Code, the Consumer may withdraw from the contract in the event of a
        delay by the other contracting party, which is an immaterial breach of the contract, on the condition that the
        party in delay does not fulfill its obligation even within an additional reasonable period that was expressly or
        tacitly provided to them.</li>
      <li>If an exact period of performance has been agreed between the Consumer and the service provider and if it
        follows from the contract or from the nature of the obligation that the Consumer cannot have an interest in
        delayed performance, the contract is terminated in accordance with the provisions of Sec. 1980 of the Civil Code
        at the beginning of the service provider&apos;s delay, unless the Consumer will notify without undue delay that
        he/she insists on fulfilling the contract.</li>
      <li>In the event
        that the service is not properly provided, the Consumer is entitled, in accordance with the provisions of Sec.
        1921 and Sec. 1923 of the Civil Code, to complain of a defect in the performance against the service provider
        immediately after its discovery and to demand, in particular, a discount on the price or, where appropriate, to
        withdraw from the contract. In accordance with the provisions of Section 19 of the Act on Consumer Protection,
        such a claim will be settled within 30 days, unless the parties to the contract agree on a longer period. A
        justified complaint is also associated with the right to reimbursement of costs purposefully incurred when
        making a complaint, which can be claimed within the time limit according to the provisions of &sect; 1924 of the
        Civil Code.</li>
      <li>The service
        provider will provide the Consumer with a written confirmation on time when the Consumer made the complaint,
        what the content of the complaint is, what method of handling the complaint the Consumer requires and the
        Consumer&apos;s contact details for the purpose of providing information about the handling of the complaint.
        The service provider will then provide the Consumer with a written confirmation of the date and method of
        settlement of the claim, or a written justification for rejecting the claim.</li>
    </ol>

    <h2>Personal Data Protection of the Costumer</h2>
    <ol>
      <li>Personal Data Protection of Clients is implemented in accordance with Act No. 101/2000 Coll., On Personal Data
        Protection and Regulation (EU) 2016/679 of the European Parliament and of the Council on the Protection of
        Individuals with regard to Personal Data Processing (General Data Protection Regulation) and it is available at
        the Website.</li>
    </ol>

    <h2>Alternative Dispute Resolution</h2>
    <ol>
      <li>The Company&rsquo;s email for complaints: <a href="mailto:info@driveczech.com">info@driveczech.com</a></li>
      <li>The Client has a right to initiate a procedure concerning an out-of-court resolution of a Consumer dispute
        (ADR) held by the Czech Trade Inspection Authority:
        <br>Česk&aacute; obchodn&iacute; inspekce
        <br>&Scaron;těp&aacute;nsk&aacute; 15, 120 00 Prague 2, Czech Republic
        <br>Email: adr@coi.cz
        <br>Web: adr.coi.cz
      </li>
      <li>The Client may use as well the platform of the EU Commission regarding online dispute resolution: <a
          href="http://ec.europa.eu/consumers/odr">http://ec.europa.eu/Consumers/odr</a>.</li>
    </ol>

    <h2>Final Provisions</h2>
    <ol>
      <li>All notices required or permitted under the Transport Agreement shall be in writing and shall be deemed
        effective upon delivery via post/Czech databox or via e-mail written in the Offer.</li>
      <li>The Client shall not be permitted to assign or transfer all or any part of its rights or obligations under the
        Contract and these Terms without the prior written consent of the Company.</li>
      <li>The laws of the Czech Republic shall apply to the entire relationship between the Company and the Client. This
        does not apply if compelling Consumer protection regulations prevail.</li>
      <li>The place of jurisdiction for all disputes resulting from and in connection with the relationship between the
        Company and the Client, in the absence of mandatory statutory provisions, be Prague 1 (Czech Republic) &ndash; a
        District Court of Prague 1 or any competent Higher Court in accordance with the Czech law.</li>
      <li>If one or more provisions of these Terms are or become invalid or ineffective, this shall not affect the
        validity or effectiveness of the remaining Terms. A provision that most closely matches the commercial intention
        of the parties in this regard shall take the place of the invalid or ineffective provision.</li>
      <li>The Terms are issued in Czech and English version, in case of any discrepancies, the Czech version shall
        prevail.</li>
      <li>The Terms are effective as of 1. 8. 2022 and supersede the previous version of the Terms. The Terms are
        available at the Website.</li>
    </ol>
  </div>

  <Footer />
</template>
